import { TableCell, TableRow } from "semantic-ui-react";
import { colors } from "../../../style";
import { SENTIMENT } from "../../../utils/meetingFormat";
import { SentimentChip } from "../../records/RecordList";
import { Avatar, DataTable } from "../../ui";

// Gold, silver and bronze, kept clear of the sentiment and avatar colours
const PODIUM = [colors.amber, "#c4c9d4", "#c98f5f"];

// Scores are 0-100; the 1-5 rating matches call sentiment chips
export const ratingFor = (score) =>
  Math.min(5, Math.max(1, Math.ceil((Number(score) || 0) / 20)));

function Rank({ position }) {
  const tint = PODIUM[position - 1];
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        borderRadius: "50%",
        fontSize: "13px",
        fontWeight: 700,
        color: tint ?? colors.textMuted,
        background: tint ? `${tint}1f` : undefined,
        border: tint ? `1px solid ${tint}66` : undefined,
      }}
    >
      {position}
    </span>
  );
}

function ScoreBar({ score, color }) {
  const value = Math.min(100, Math.max(0, Number(score) || 0));
  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        minWidth: 0,
      }}
    >
      <span
        style={{
          fontVariantNumeric: "tabular-nums",
          fontWeight: 600,
          width: "2.2em",
          textAlign: "right",
        }}
      >
        {value}
      </span>
      <span
        aria-hidden="true"
        style={{
          flex: 1,
          height: 6,
          borderRadius: 3,
          background: colors.raised,
          overflow: "hidden",
          minWidth: 60,
        }}
      >
        <span
          style={{
            display: "block",
            width: `${value}%`,
            height: "100%",
            borderRadius: 3,
            background: color,
          }}
        />
      </span>
    </span>
  );
}

// Same score, same position (1, 1, 3). Rows arrive sorted by score.
export const positions = (rows) =>
  rows.map((row, i) => {
    let first = i;
    while (first > 0 && Number(rows[first - 1].score) === Number(row.score)) {
      first--;
    }
    return first + 1;
  });

export const LeaderboardTable = ({ data }) => {
  const ranks = positions(data);
  return (
    <DataTable
      columns={[
        { key: "position", label: "#", width: 1, align: "center" },
        { key: "name", label: "Name", width: 7 },
        { key: "score", label: "Score", width: 5 },
        { key: "sentiment", label: "Sentiment", width: 3 },
      ]}
    >
      {data.map((e, i) => {
        const rating = ratingFor(e.score);
        const name =
          [e.user.first_name, e.user.last_name].filter(Boolean).join(" ") ||
          `Ext ${e.user.extension}`;
        return (
          <TableRow key={e.user.id}>
            <TableCell textAlign="center">
              <Rank position={ranks[i]} />
            </TableCell>
            <TableCell>
              <span
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <Avatar name={name} size={28} />
                <span style={{ fontWeight: 500 }}>{name}</span>
              </span>
            </TableCell>
            <TableCell>
              <ScoreBar score={e.score} color={SENTIMENT[rating].color} />
            </TableCell>
            <TableCell>
              <SentimentChip sentiment={{ rating }} size="sm" />
            </TableCell>
          </TableRow>
        );
      })}
    </DataTable>
  );
};
